import { render, staticRenderFns } from "./NoPermissionToContact.vue?vue&type=template&id=cc9a0392"
import script from "./NoPermissionToContact.vue?vue&type=script&lang=js"
export * from "./NoPermissionToContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports